import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs/operators';
import { ToastActions } from './toast.actions';
import { UiToastComponent, UiToastData } from '../../shared/components/ui/ui-toast/ui-toast.component';

@Injectable()
export class ToastEffects {
  private actions$ = inject(Actions);
  private snackBar = inject(MatSnackBar);

  showToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ToastActions.showToast),
        tap(({ severity, summary, detail }) => {
          const message = detail || summary;
          const panelClass = [`toast-${severity}`];
          this.snackBar.openFromComponent<UiToastComponent, UiToastData>(UiToastComponent, {
            data: { message },
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
            panelClass,
          });
        }),
      ),
    { dispatch: false },
  );
}
